<template>
  <div
    class="w-full py-8 flex flex-col transition-3"
    :class="hasMenuList && opened ? 'gap-10' : 'gap-0'"
  >
    <div
      v-if="hasMenuList"
      class="flex items-center justify-between cursor-pointer"
      @click="handleOpenClose()"
    >
      <p class="text-gray-95 text-small-semibold">{{ title.text }}</p>
      <button v-if="hasMenuList">
        <Icon icon="line-md:chevron-up" width="20" :class="!opened ? 'rotate-180' : ''" />
      </button>
    </div>
    <div v-else class="w-full cursor-pointer" @click="onClickMenu(title.to)">
      <p
        :class="[
          'text-small-semibold',
          title.to === currentRoute ? 'text-primary-50' : 'text-gray-95'
        ]"
      >
        {{ title.text }}
      </p>
    </div>

    <div
      :class="[
        'grid transition-3 overflow-hidden',
        opened ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      ]"
    >
      <div class="overflow-hidden">
        <ul class="flex flex-col gap-4">
          <li v-for="(menu, index) in menuList" :key="index">
            <BtnText
              size="lg"
              bold="regular"
              :label="menu.text"
              :active="currentRoute === menu.to"
              @click="onClickMenu(menu.to)"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import BtnText from '@/shared/ui/components/button/BtnText.vue'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

type Props = {
  title: { text: string; to: string }
  menuList: { text: string; to: string }[]
}
const props = defineProps<Props>()
const emits = defineEmits(['click'])

const route = useRoute()

const opened = ref<boolean>(true)
const currentRoute = computed(() => route.path)
const hasMenuList = computed(() => props.menuList.length > 0)

watch(
  () => props.title,
  (newVal) => {
    opened.value = true
  },
  { immediate: true }
)

const handleOpenClose = () => {
  opened.value = !opened.value
}
const onClickMenu = (to: string) => {
  emits('click', to)
}
</script>
